(() => {
  'use strict';
  const dialog = document.getElementById('neb-cart-dialog');
  const theme = window.CTTheme;
  if (!dialog || !theme || typeof dialog.showModal !== 'function') return;
  const strings = JSON.parse(dialog.querySelector('[data-neb-bag-strings]').textContent);
  let trigger;
  let opening;
  let busy = false;
  let debounce;
  const pending = new Map();
  const pageCart = () => document.querySelector('[data-ct-cart]');
  const surfaces = () => document.querySelectorAll('[data-neb-cart-surface]');
  const announce = message => surfaces().forEach(surface => { const status = surface.querySelector('[data-ct-cart-status]'); if (status) status.textContent = message; });
  const setBusy = value => surfaces().forEach(surface => {
    surface.setAttribute('aria-busy',String(value));
    surface.querySelectorAll('input,button:not([data-neb-bag-close])').forEach(control => { control.disabled = value; });
  });
  const count = value => {
    const total = Math.max(0,Number(value) || 0);
    document.querySelectorAll('[data-ct-cart-count]').forEach(node => { node.textContent = String(total); });
    document.dispatchEvent(new CustomEvent('neb:cart-count-changed',{detail:{count:total}}));
  };
  const parse = html => new DOMParser().parseFromString(html,'text/html');
  const replaceBag = html => {
    const replacement = parse(html).querySelector('[data-neb-bag-content]');
    if (!replacement) throw new Error(strings.retry);
    dialog.querySelector('[data-neb-bag-content]').replaceWith(replacement);
    count(Number(replacement.dataset.itemCount) || 0);
  };
  const refresh = async () => {
    const url = new URL(theme.routes.cart,location.origin);
    url.searchParams.set('sections','neb-cart-drawer');
    const response = await fetch(url,{headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error(strings.retry);
    const result = await response.json();
    if (!result['neb-cart-drawer']) throw new Error(strings.retry);
    replaceBag(result['neb-cart-drawer']);
  };
  const show = opener => {
    trigger = opener || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('neb-bag-open');
    trigger?.setAttribute('aria-expanded','true');
  };
  const open = async (opener,sectionHTML) => {
    show(opener);
    if (sectionHTML) { replaceBag(sectionHTML);dialog.querySelector('[data-neb-bag-close]')?.focus();return; }
    if (opening) return opening;
    announce(strings.loading);
    opening = refresh().catch(() => { announce(strings.retry); }).finally(() => { opening = null;if (dialog.open) dialog.querySelector('[data-neb-bag-close]')?.focus(); });
    return opening;
  };
  window.NebCart = {
    added: async (result,opener) => {
      if (result.sections?.['neb-cart-drawer']) return open(opener,result.sections['neb-cart-drawer']);
      await refresh();show(opener);dialog.querySelector('[data-neb-bag-close]')?.focus();
    },
    open
  };
  dialog.addEventListener('close',() => { document.documentElement.classList.remove('neb-bag-open');trigger?.setAttribute('aria-expanded','false');if(trigger?.isConnected)trigger.focus({preventScroll:true}); });
  dialog.addEventListener('click',event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) dialog.close();
  });
  const update = async () => {
    if (busy) return;
    busy = true;
    try {
      while (pending.size) {
        const [id,quantity] = pending.entries().next().value;pending.delete(id);
        const cart = pageCart();
        const sectionIds = ['neb-cart-drawer',...(cart ? [cart.dataset.sectionId] : [])];
        const active = document.activeElement;
        const activeLine = active?.closest('[data-line-key]')?.dataset.lineKey;
        const activeId = active?.id;
        const oldTop = active?.getBoundingClientRect().top;
        const note = cart?.querySelector('[name="note"]')?.value;
        const noteOpen = cart?.querySelector('.neb-cart-note')?.open;
        setBusy(true);announce(strings.updating);
        const response = await fetch(theme.routes.change+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:AbortSignal.timeout(15000),body:JSON.stringify({id,quantity,sections:sectionIds,sections_url:theme.routes.cart})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description||result.message||strings.retry);
        if (!result.sections?.['neb-cart-drawer']) throw new Error(strings.retry);
        replaceBag(result.sections['neb-cart-drawer']);
        if (cart) {
          const html = result.sections[cart.dataset.sectionId];
          const replacement = html && parse(html).querySelector('[data-ct-cart]');
          if (!replacement) throw new Error(strings.retry);
          const input = replacement.querySelector('[name="note"]');
          if (input && note !== undefined) input.value = note;
          if (noteOpen && replacement.querySelector('.neb-cart-note')) replacement.querySelector('.neb-cart-note').open = true;
          cart.replaceWith(replacement);
        }
        count(result.item_count);
        announce(strings.updated);
        if (activeLine) {
          const scope = dialog.open ? dialog : pageCart();
          const line = [...(scope?.querySelectorAll('[data-line-key]')||[])].find(node=>node.dataset.lineKey===activeLine);
          const focus = (activeId && document.getElementById(activeId)) || line?.querySelector('input') || (dialog.open ? dialog.querySelector('[data-neb-bag-close]') : pageCart()?.querySelector('h1'));
          if (focus) { focus.focus({preventScroll:true});if(!dialog.open&&Number.isFinite(oldTop))window.scrollBy(0,focus.getBoundingClientRect().top-oldTop); }
        }
      }
    } catch (error) {
      pending.clear();
      surfaces().forEach(surface=>surface.querySelectorAll('[data-ct-cart-quantity]').forEach(input=>{input.value=input.getAttribute('value');}));
      announce(error.name==='TimeoutError'?strings.retry:error.message||strings.retry);
    } finally { busy=false;setBusy(false); }
  };
  document.addEventListener('click',event => {
    const opener = event.target.closest('[data-neb-bag-open]');
    if (opener && event.button===0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { event.preventDefault();open(opener);return; }
    if (event.target.closest('[data-neb-bag-close]')) { dialog.close();return; }
    const remove = event.target.closest('[data-ct-remove]');
    if (!remove || !remove.closest('[data-neb-cart-surface]')) return;
    event.preventDefault();clearTimeout(debounce);pending.set(remove.closest('[data-line-key]').dataset.lineKey,0);update();
  });
  document.addEventListener('change',event => {
    if (!event.target.matches('[data-ct-cart-quantity]')) return;
    const input = event.target;const quantity=Number(input.value);
    if (!Number.isInteger(quantity)||quantity<0||!input.checkValidity()) { input.reportValidity();return; }
    clearTimeout(debounce);pending.set(input.closest('[data-line-key]').dataset.lineKey,quantity);debounce=setTimeout(update,180);
  });
})();
